import { Component, OnInit, NgModule, Input, Output } from '@angular/core';
import { Router, ActivatedRoute, Routes, RouterModule } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { BaseRequestService } from '../../services/base-request.service';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { APIConfing } from '../../services/apiconfing.service';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxTextBoxModule, DxTooltipModule, DxFormModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { CommonPreLoadedService } from 'src/app/core/services/common/common-pre-loaded.service';
import { catchError } from 'rxjs/operators';
import { Subscription, throwError } from 'rxjs';
import { CoreModule } from 'src/app/core/core.module';
import { EventEmitter } from '@angular/core';
import { AuthService } from '../../services';

@Component({
  selector: 'app-essnew-password',
  templateUrl: './essnew-password.component.html',
  styleUrls: ['./essnew-password.component.scss'],
  standalone: false
})
export class ESSNewPasswordComponent implements OnInit {
  @Input() passwordModel: any;
  @Output() emitNewPassRes = new EventEmitter<any>();
  newPasswordModel: any = {
    consEmailID: '',
    consultantID: 0,
    consPass: '',
    reConsPass: ''
  };
  validEmailInfo: any;
  errMsg: string;
  isVisible = false;
  passwordMode: string;
  passwordPattern = /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*[^\w\s])\S{8,}$/;
  custNewPasswd: any = {
    text: 'Create',
    useSubmitBehavior: true,
    width: '100%',
    icon: '',
    type: 'success'
  };
  passwordBtn: any = {
    icon: 'fa fa-eye',
    type: 'default',
    onClick: () => {
      this.passwordMode = this.passwordMode === 'text' ? 'password' : 'text';
    }
  };
  defaultVisible = false;
  spinnerProp: any = {
    bdColor: '',
    fullScreen: false,
    size: '',
    color: '',
    type: ''
  };
  spinnerNewPassWord = 'newPassWord';
  isSubLogo: Subscription;
  getImgLogo: any;
  isShowImgLogo: boolean;

  constructor(private router: Router, private route: ActivatedRoute, public common: CommonService, private toastrService: ToastrService,
    private baseRequset: BaseRequestService, private spinner: NgxSpinnerService, private commonAPI: CommonPreLoadedService,
    private authService: AuthService) {
    this.spinnerProp.bdColor = APIConfing.data.spinnerProp.bdColor;
    this.spinnerProp.fullScreen = APIConfing.data.spinnerProp.fullScreen;
    this.spinnerProp.size = APIConfing.data.spinnerProp.size;
    this.spinnerProp.color = APIConfing.data.spinnerProp.color;
    this.spinnerProp.type = APIConfing.data.spinnerProp.type;

    this.isSubLogo = this.commonAPI.getCustomerLogo$().pipe(catchError(err => throwError(err)))
      .subscribe(obj => {
        if (obj && obj.length > 0) {
          this.getImgLogo = obj[0].logoURL;
          this.isShowImgLogo = true;
          this.commonAPI.customerLogo.next(null);
        } else if (obj && obj.length === 0) {
          this.isShowImgLogo = false;
          this.getImgLogo = null;
        }
      });
  }

  ngOnInit() {
    // this.route.queryParams
    //   .subscribe(params => {
    this.newPasswordModel.consEmailID = this.passwordModel.consEmailID;
    this.newPasswordModel.consultantID = this.passwordModel.consultantID;
    this.newPasswordModel.cid = this.passwordModel.cid || 0;
    this.errMsg = null;
    //   });
    if (this.newPasswordModel.cid > 0) {
      this.commonAPI.fnGetCustomerLogoURL(this.newPasswordModel.cid, 1);
    } else {
      this.isShowImgLogo = false;
    }
  }

  fnNewPassword(data: any) {
    this.spinner.show(this.spinnerNewPassWord);
    this.baseRequset.fnpost('/CSS/Consultant/ResetConsultantPasswd', this.common.fnReturnEncryptedPayload(data))
      .subscribe((getResData: any) => {
        if (getResData && getResData.code === this.common.status.success) {
          this.toastrService.success(getResData.message, 'Success');
          // this.router.navigate(['/login']);
          this.authService.logout();
          this.spinner.hide(this.spinnerNewPassWord);
        } else if (getResData.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002, 'Error');
          this.spinner.hide(this.spinnerNewPassWord);
        } else if (getResData.code === 'E001') {
          this.toastrService.error(getResData.message, 'Error');
          this.spinner.hide(this.spinnerNewPassWord);
        } else if (getResData.code === this.baseRequset.warning.code) {
          this.toastrService.warning(getResData.message, 'Details');
          this.spinner.hide(this.spinnerNewPassWord);
        } else {
          this.spinner.hide(this.spinnerNewPassWord);
        }
      }, err => {
        this.toastrService.error(APIConfing.data.E002);
        this.spinner.hide(this.spinnerNewPassWord);
      });
  }

}

const routes: Routes = [
  { path: '', component: ESSNewPasswordComponent }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    // DxButtonModule,
    // DxTextBoxModule,
    DxFormModule,
    FormsModule,
    DxTooltipModule,
    // NgxSpinnerModule,
    CoreModule
  ],
  declarations: [ESSNewPasswordComponent],
  exports: [RouterModule, ESSNewPasswordComponent]
})
export class ESSNewPasswordModule { }
